import { Button, ButtonProps } from "@chakra-ui/react";

import { toTitleCase } from "src/utils";

import { OFText } from "../OFText";
import { BUTTONS_THEMES, ButtonVariantType } from "./button";

export type OFButtonProps = ButtonProps & {
  variant?: ButtonVariantType;
};

export const OFButton = ({ variant = "primary", children, ...props }: OFButtonProps) => {
  const buttonTheme = props.disabled
    ? { ...BUTTONS_THEMES.primaryBlack }
    : { ...BUTTONS_THEMES[variant] };
  return (
    <Button
      borderWidth={2}
      borderStyle="solid"
      borderRadius={60}
      px={8}
      py={3}
      _focus={{ boxShadow: "none" }}
      w="max-content"
      {...buttonTheme}
      {...props}
    >
      <OFText color="inherit" textStyle="button1">
        {typeof children === "string" ? toTitleCase(children) : children}
      </OFText>
    </Button>
  );
};
